export default __webpack_public_path__ + "static/media/girts.30b3a275.jpg";